import { RouteObject } from 'react-router-dom'
import { lazy } from 'react'
import ModuleGuard from '@/core/guards/ModuleGuard.tsx'
import ErrorPage from '@/pages/errors/ErrorPage.tsx'

const TEACHING_ROUTES: RouteObject[] = [
  {
    path: 'teaching',
    element: <ModuleGuard />,
    errorElement: <ErrorPage />,
    children: [
      {
        path: 'videosCategory',
        lazy: async () => {
          const VideosPage = lazy(
            () =>
              import('@/pages/teaching/videosCategory/VideosCategoryPage.tsx')
          )
          return { element: <VideosPage /> }
        }
      },
      {
        path: 'videos',
        lazy: async () => {
          const VideosPage = lazy(
            () => import('@/pages/teaching/videos/VideosPage.tsx')
          )
          return { element: <VideosPage /> }
        }
      },
      {
        path: 'videoList',
        lazy: async () => {
          const VideoListPage = lazy(
            () => import('@/pages/teaching/videoList/VideoListPage.tsx')
          )
          return { element: <VideoListPage /> }
        }
      }
    ]
  }
]

export default TEACHING_ROUTES
